interface IHotelPushMessageGroupMessageTypes {
  text: string;
  image: string;
  externalImage: string;
  button: string;
  carousels: string;
  // quickReply: string;
}

export const HotelPushMessageGroupMessageTypes: IHotelPushMessageGroupMessageTypes =
  {
    text: "text",
    image: "image",
    externalImage: "external_image",
    button: "button",
    carousels: "carousels",
    // quickReply: "quick_reply",
  };
